import useGetApi from 'src/api/useGetApi';
import { ProductV2DTO } from 'src/types/application/inventory-management/ProductV2DTO';

interface PageInfo {
  currentPage: number;
  totalPages: number;
  totalCount: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

interface PaginatedResponse<T> {
  edges: T[];
  pageInfo: PageInfo;
}

type ListProductsResponseDTO = PaginatedResponse<ProductV2DTO>;

interface QueryParams {
  page: number;
  pageSize: number;
  categoryId?: string;
  isSellable?: boolean;
  isActive?: boolean;
  search?: string;
  name?: string;
  includes?: Array<'attributes'>;
}

const useProductsV2 = (params?: QueryParams, enabled?: boolean) => {
  return useGetApi<ListProductsResponseDTO>({
    endpoint: 'inventory-management/products-v2',
    queryParameters: params,
    options: {
      enabled,
    },
  });
};

export default useProductsV2;
